<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择分类"
            style="width: 100%"
            name="place"
            optionFilterProp="children"
            allow-clear
            v-decorator="['place', { rules: [{ required: true, message: '请选择分类' }] }]"
          >
            <a-select-option v-for="(key, index) in selectList" :key="index.toString()">
              {{ key }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="4"
            name="keyword"
            placeholder="请输入标签"
            v-decorator="['keyword', { rules: [{ required: true, message: '请输入目标描述' }] }]"
          />
        </a-form-item>

        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>

        <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="content"
            v-decorator="['content', { rules: [{ required: true, message: '请输入文章内容' }] }]"
          />
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
          <a-input-number
            name="order"
            v-decorator="[
              'order',
              {
                initialValue: 0
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { UEditor, GoBack } from '@/components'
import { form, select } from '@/mixins'
const fields = ['place', 'title', 'content', 'order', 'state', 'keyword', 'desc']
const apiList = {
    getInfo: '/settings/articles/',
    selectList: '/settings/articles/place',
    create: '/settings/articles/create',
    update: '/settings/articles/'
}
export default {
    name: 'ArtForm',
    mixins: [form, select],
    components: {
        UEditor,
        GoBack
    },
    data () {
        return {
            fields,
            apiList,
            selectList: [], // 分类下拉数据
            aid: this.$route.params.id
        }
    },

    mounted () {
        if (this.$route.params.id) {
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1
                values.place = values.place.toString()
            }) // 获取编辑信息
        }
        this.getSelectLists({
            url: apiList.selectList
        }) // 获取分类下拉
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-28 18:36:32
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 整理表单数据
         * @param  {*}
         * @return {*}
         */
        setFormData (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        }

    }
}
</script>
